import styled from 'styled-components';
import colors from 'styles/colors';

import { FLASH_MESSAGE_TYPES } from 'constants/common';

export const FlashMessageContainer = styled.div`
  position: fixed;
  top: 120px;
  left: calc(50%);
  transform: translate(-50%, 0);
  max-width: 410px;
  min-width: 250px;
  z-index: 999;
  transition: 0.15s opacity ease-in-out;
`;

export const InnerContent = styled.div`
  margin: 0 24px 0 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.7px;
  display: flex;
  align-items: center;
  flex-direction: column;

  h4 {
    line-height: 1em;
  }
`;

export const Content = styled.pre`
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(160, 160, 160, 0.7);
  color: ${colors.white};
  padding: 13px 20px;
  position: relative;
  hyphens: none;
  white-space: pre-line;
  word-break: break-word;

  ${(props) => {
    // @ts-expect-error TS(2339): Property 'type' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    if (props.type === FLASH_MESSAGE_TYPES.success) {
      return `
                background-color: ${colors.success};
            `;
    }

    // @ts-expect-error TS(2339): Property 'type' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    if (props.type === FLASH_MESSAGE_TYPES.error) {
      return `
                background-color: ${colors.danger};
            `;
    }

    // @ts-expect-error TS(2339): Property 'type' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    if (props.type === FLASH_MESSAGE_TYPES.warning) {
      return `
                background-color: ${colors.warning};
                color: ${colors.primary};
            `;
    }

    // @ts-expect-error TS(2339): Property 'type' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    if (props.type === FLASH_MESSAGE_TYPES.info) {
      return `
                background-color: ${colors.info};
            `;
    }

    return null;
  }};
`;

export const Close = styled.i`
  position: absolute;
  font-size: 12px;
  font-weight: 800;
  top: 17px;
  right: 20px;
  cursor: pointer;
`;
